import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import { Input } from "@/components/ui/input"
import { Textarea } from "@/components/ui/textarea"
import { UseFormReturn } from "react-hook-form"
import { CatalogFormData } from "../catalog-form-schema"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"

const eventFormatOptions = [
  { value: "In-Office", label: "In-Office" },
  { value: "Virtual", label: "Virtual" },
  { value: "Outdoor", label: "Outdoor" },
  // { value: "Kiosk", label: "Kiosk" },
  // { value: "Hybrid", label: "Hybrid" },
]

const eventDurationOptions = [
  { value: "30 mins", label: "30 mins" },
  { value: "60 mins", label: "60 mins" },
  { value: "90 mins", label: "90 mins" },
  { value: "120 mins", label: "120 mins" },
  { value: "180 mins", label: "180 mins" },
  { value: "Half day", label: "Half day" },
  { value: "Full day", label: "Full day" },
]

interface BasicDetailsProps {
  form: UseFormReturn<CatalogFormData>
}

export function BasicDetails({ form }: BasicDetailsProps) {
  return (
    <>
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Title</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Description</FormLabel>
            <FormControl>
              <Textarea {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="format"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Location Format</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select event format" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {eventFormatOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="duration"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Duration</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select event duration" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {eventDurationOptions.map((option) => (
                    <SelectItem key={option.value} value={option.value}>
                      {option.label}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      { false && (<FormField
        control={form.control}
        name="format_details"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Location Details <span className="text-xs text-muted-foreground">(add location or a remark for the booker to note)</span></FormLabel>
            <FormControl>
              <Input 
                {...field} 
                placeholder={
                  form.watch("event_format_type") === "Virtual" 
                    ? "Enter meeting link" 
                    : "Enter address or map link"
                }
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />)}
    </>
  )
}